<ng-container *transloco="let t">
  @let parameters = question().parameters;
  @let placeholder = parameters?.placeholder ?? '';
  @let iconStart = question().icon | formIcon;

  @switch (question().type) {
    @case (QuestionType.TEXT) {
      <ng-container *ngTemplateOutlet="textArea; context: { testid: 'text-input' }" />
    }
    @case (QuestionType.RICH_TEXT) {
      <ng-container *ngTemplateOutlet="textArea; context: { testid: 'rich-text-input' }" />
    }
    @case (QuestionType.NUMBER) {
      <pxc-form-question-number
        [control]="control()"
        [iconStart]="iconStart"
        [mode]="mode()"
        [question]="question()"
        [readOnly]="isReadOnly()" />
    }
    @case (QuestionType.BOOL) {
      @if (isReadOnly() && !isForm()) {
        <span data-testid="toggle-readonly">{{ control().value ? t('Oui') : t('Non') }}</span>
      } @else {
        <input
          data-testid="toggle-input"
          ngDefaultControl
          size="m"
          tuiSwitch
          type="checkbox"
          [formControl]="control()"
          [readOnly]="isReadOnly()" />
      }
    }
    @case (QuestionType.CHECKBOX) {
      <pxc-form-question-checkbox
        [control]="checkboxControl()"
        [mode]="mode()"
        [question]="question()"
        [readOnly]="isReadOnly()" />
    }
    @case (QuestionType.RADIO) {
      <pxc-form-question-radio
        [control]="control()"
        [mode]="mode()"
        [question]="question()"
        [readOnly]="isReadOnly()" />
    }
    @case (QuestionType.DATE) {
      @if (isReadOnly() && !isForm()) {
        <span class="flex items-center h-full px-3" data-testid="date-readonly">{{ control().value | date }}</span>
      } @else {
        @let dateLabel = placeholder || question().title;
        <tui-textfield>
          @if (isForm()) {
            <label tuiLabel [attr.for]="'date-' + question().id">{{ dateLabel }}</label>
          }
          <input
            ngDefaultControl
            tuiInputDate
            [formControl]="control()"
            [id]="'date-' + question().id"
            [placeholder]="placeholder || t('jj/mm/aaaa')"
            [readOnly]="isReadOnly()" />
          <tui-calendar *tuiDropdown />
        </tui-textfield>
      }
    }
  }

  <ng-template #textArea let-testid="testid">
    <tui-textfield class="w-full" [iconStart]="iconStart">
      <textarea
        maxlength="65535"
        ngDefaultControl
        tuiTextarea
        [attr.data-testid]="testid"
        [formControl]="control()"
        [max]="32"
        [min]="isForm() ? 2 : 1"
        [placeholder]="placeholder"
        [readOnly]="isReadOnly()"></textarea>
    </tui-textfield>
  </ng-template>
</ng-container>
